const filterVideos = function filterVideosNotInLanguage(videos, lang) {
  return videos.filter(video => video.langs.includes(lang));
};

const filterLanguage = function checkToSeeIfLanguageHasVideo(pageData) {
  const data = pageData;
  const filteredVideos = filterVideos(data.videos, data.languageId);
  data.videos =
    filteredVideos.length > 0
      ? filteredVideos
      : filterVideos(data.videos, data.defaultLanguage);
  return data;
};

export default filterLanguage;



// WEBPACK FOOTER //
// ./src/components/filterLanguage.js